import styled from 'styled-components'

export const PriceRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: baseline;
`
